/**
 * UAVTradeZone Modification Record
 *
 * Change ID:    DASHBOARD_SEARCH_ALIGNMENT_FIX
 * Date:         2025-12-28
 * Modified By:  Cursor
 *
 * Description:
 * Fixed search banner alignment to match other dashboard items. Removed nested container
 * and inline styles that constrained width. Now uses full available width within container
 * and aligns properly with DashboardProfileBoxes and DashboardBroadcastList.
 *
 * Related Screens / Modules:
 * - client/src/features/dashboard/DashboardSearchBanner.tsx
 * - client/src/pages/Dashboard.tsx
 */

import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
// Note: backgroundImage kept inline - public folder URL can't be resolved in SCSS modules

const DashboardSearchBanner: React.FC = () => {
  const navigate = useNavigate();
  // [2025-12-11] Search: Add state for search input value
  const [searchValue, setSearchValue] = useState("");

  // [2025-12-11] Search: Navigate to search page with search query (global search)
  const handleSearch = () => {
    if (searchValue.trim()) {
      navigate(`/search?q=${encodeURIComponent(searchValue.trim())}`);
    } else {
      navigate("/search");
    }
  };

  const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      handleSearch();
    }
  };

  // [2025-12-28] Alignment: Remove nested container and width constraints to match other dashboard items
  return (
    <section className="my-4" role="search" aria-label="Site search">
      <div
        className="dashboard-search-banner-card card-body py-5 row align-items-center"
        style={{ backgroundImage: "url('/assets/hero.png')" }}
      >
        <div className="col-12 col-lg-10 ps-lg-5">
          <div className="d-flex align-items-center gap-3 mb-3">
            {/* [2026-02-13] Maya: Figma alignment - H1 30px SemiBold */}
            <label htmlFor="dashboardSearch" className="mb-0 u-H1-30">
              What are you looking for today?
            </label>
          </div>

          <div className="d-flex align-items-center position-relative search-input-container">
            <input
              id="dashboardSearch"
              type="search"
              className="form-control radius-pill input-pill search-input u-P2-16"
              placeholder="SKU, Keyword, Manufacturer or Company"
              aria-label="Search by SKU, keyword, manufacturer or company"
              value={searchValue}
              onChange={(e) => setSearchValue(e.target.value)}
              onKeyPress={handleKeyPress}
            />
            <button
              type="button"
              className="btn-search-figma position-absolute btn-search-position"
              onClick={handleSearch}
              aria-label="Search"
            >
              Search
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DashboardSearchBanner;
